import * as PIXI from 'pixi.js';
import { languageManager } from './languageManager';

export class HelpPopUp extends PIXI.Container {
  constructor(buttonsSheet, menubtnsSheet, onClose) {
    super();
    this.buttonsSheet = buttonsSheet;
    this.menubtnsSheet = menubtnsSheet;
    this.onClose = onClose;
    this.interactive = true;
    this.visible = false;
    this.textElements = {};
    this.createPopup();
    window.addEventListener('resize', () => this.resizePopup());
    document.addEventListener('fullscreenchange', () => this.resizePopup());
    
    // Listen for language changes
    languageManager.addListener(() => this.updateLanguage());
  }

  createPopup() {
    this.overlay = new PIXI.Graphics();
    this.drawOverlay();
    this.overlay.interactive = true;
    this.addChild(this.overlay);

    this.content = new PIXI.Container();
    // this.content.x = 40;
    // this.content.y = 40;
    this.addChild(this.content);

    this.maskGraphics = new PIXI.Graphics();
    this.drawMask();
    this.addChild(this.maskGraphics);
    this.content.mask = this.maskGraphics;

    const titleStyle = new PIXI.TextStyle({
      fontFamily: 'Arial', fill: '#eae9e2', fontWeight: 'bold',
    });
    const title = new PIXI.Text(languageManager.getText('helpPage.title'), titleStyle);
    this.textElements.title = new PIXI.Text(languageManager.getText('helpPage.title'), titleStyle);
    this.content.addChild(this.textElements.title);

    // Divider
    this.divider = new PIXI.Graphics();
    this.content.addChild(this.divider);

    // Game Rules
    const rulesTitleStyle = new PIXI.TextStyle({
      fontFamily: 'Arial', fill: '#ffd700', fontWeight: 'bold', align: 'center',
    });

    this.textElements.rulesTitle = new PIXI.Text(languageManager.getText('helpPage.rulesTitle'), rulesTitleStyle);
    this.content.addChild(this.textElements.rulesTitle);
    
    this.rulesDivider = new PIXI.Graphics();
    this.content.addChild(this.rulesDivider);

    const bulletStyle = new PIXI.TextStyle({
      fontFamily: 'Arial', fill: '#fffbe0', fontWeight: 'bold', align: 'left', lineHeight: 26, wordWrap: true
    });
    this.bulletTexts = [];
    const bullets = [
        languageManager.getText('helpPage.rule1'),
        languageManager.getText('helpPage.rule2'),
        languageManager.getText('helpPage.rule3'),
        languageManager.getText('helpPage.rule4'),
        languageManager.getText('helpPage.rule5'),
        languageManager.getText('helpPage.rule6'),
        languageManager.getText('helpPage.rule7'),
        languageManager.getText('helpPage.rule8'),
        languageManager.getText('helpPage.rule9'),
        languageManager.getText('helpPage.rule10')
    ];

    bullets.forEach((bullet, index) => {
      const bulletText = new PIXI.Text('• ' + bullet, bulletStyle);
      this.content.addChild(bulletText);
      this.textElements[`rule${index + 1}`] = bulletText;
      this.bulletTexts.push(bulletText);
      });

    const functionsTitleStyle = new PIXI.TextStyle({
      fontFamily: 'Arial', fill: '#ffd700', fontWeight: 'bold', align: 'center',
    });
    const functionsTitle = new PIXI.Text(languageManager.getText('helpPage.functionsTitle'), functionsTitleStyle);
    this.textElements.functionsTitle = new PIXI.Text(languageManager.getText('helpPage.functionsTitle'), functionsTitleStyle);
    this.content.addChild(this.textElements.functionsTitle);

    this.functionsDivider = new PIXI.Graphics();
    this.content.addChild(this.functionsDivider);

    const functionsDescStyle = new PIXI.TextStyle({
      fontFamily: 'Arial', fill: '#eae9e2', align: 'center', wordWrap: true
    });
    this.textElements.functionsDesc = new PIXI.Text(languageManager.getText('helpPage.functionsDesc'), functionsDescStyle);
    this.content.addChild(this.textElements.functionsDesc);

    // Table elements
    this.tableBorder = new PIXI.Graphics();
    this.content.addChild(this.tableBorder);

    this.headerBg = new PIXI.Graphics();
    this.content.addChild(this.headerBg);

    const headerStyle = new PIXI.TextStyle({ fontFamily: 'Arial', fill: '#ffd700', fontWeight: 'bolder', align: 'center' });
    this.textElements.buttonHeader = new PIXI.Text(languageManager.getText('helpPage.buttonHeader'), headerStyle);
    this.content.addChild(this.textElements.buttonHeader);
        
    this.textElements.functionHeader = new PIXI.Text(languageManager.getText('helpPage.functionHeader'), headerStyle);
    this.content.addChild(this.textElements.functionHeader);
   
    this.tableRows = [];

    const rowData = [
      { key: 'Buy_normal_btn.png', descKey: 'helpPage.buyButtonDesc' },
      { key: 'reveal_all_normal_btn.png', descKey: 'helpPage.revealButtonDesc' },
      { key: 'bet_value_normal_base.png', descKey: 'helpPage.betButtonDesc' },
      { key: 'info_normal_btn.png', descKey: 'helpPage.infoButtonDesc' },
      { key: 'menu_normal_btn.png', descKey: 'helpPage.menuButtonDesc' },
      { key: 'sounds.png', descKey: 'helpPage.soundsButtonDesc' },
      { key: 'language.png', descKey: 'helpPage.languageButtonDesc' },
      { key: 'history.png', descKey: 'helpPage.historyButtonDesc' },
    ];
    rowData.forEach((data, i) => {
      const rowLine = new PIXI.Graphics();
      this.content.addChild(rowLine);

      let texture = null;
      if (this.buttonsSheet && this.buttonsSheet.textures && this.buttonsSheet.textures[data.key]) {
        texture = this.buttonsSheet.textures[data.key];
      } else if (this.menubtnsSheet && this.menubtnsSheet.textures && this.menubtnsSheet.textures[data.key]) {
        texture = this.menubtnsSheet.textures[data.key];
      }
      const sprite = texture ? new PIXI.Sprite(texture) : null;
      if (sprite) this.content.addChild(sprite);
    
      const descStyle = new PIXI.TextStyle({ fontFamily: 'Arial', fill: '#fffbe0', fontWeight: 'bolder', align: 'left', wordWrap: true });
      const desc = new PIXI.Text(languageManager.getText(data.descKey), descStyle);
      this.content.addChild(desc);
      this.tableRows.push({ rowLine, sprite, desc, descKey: data.descKey });
   });

   const featuresTitleStyle = new PIXI.TextStyle({ fontFamily: 'Arial', fill: '#ffd700', fontWeight: 'bold', align: 'center' });
  this.textElements.featuresTitle = new PIXI.Text(languageManager.getText('helpPage.featuresTitle'), featuresTitleStyle);
  this.content.addChild(this.textElements.featuresTitle);

  this.featuresDivider = new PIXI.Graphics();
  this.content.addChild(this.featuresDivider);

  const featuresDescStyle = new PIXI.TextStyle({ fontFamily: 'Arial', fill: '#eae9e2', align: 'left', wordWrap: true });
  this.textElements.featuresDesc = new PIXI.Text(languageManager.getText('helpPage.featuresDesc'), featuresDescStyle);
  this.content.addChild(this.textElements.featuresDesc);

  const featuresBulletStyle = new PIXI.TextStyle({ fontFamily: 'Arial', fill: '#fffbe0', fontWeight: 'bolder', align: 'left', lineHeight: 26, wordWrap: true });
  this.featureBullets = [];
  const featureBulletData = [
    languageManager.getText('helpPage.bonusFeature'),
    languageManager.getText('helpPage.scatterFeature'),
  ];
  featureBulletData.forEach(bullet => {
    const bulletText = new PIXI.Text('• ' + bullet, featuresBulletStyle);
    this.content.addChild(bulletText);
    this.featureBullets.push(bulletText);
  });

  let closeTexture = null;
  if (this.buttonsSheet && this.buttonsSheet.textures && this.buttonsSheet.textures['close.png']) {
    closeTexture = this.buttonsSheet.textures['close.png'];
  } else if (this.menubtnsSheet && this.menubtnsSheet.textures && this.menubtnsSheet.textures['close.png']) {
    closeTexture = this.menubtnsSheet.textures['close.png'];
  }
  if (closeTexture) {
    this.closeBtn = PIXI.Sprite.from(closeTexture);
    this.closeBtn.anchor.set(1, 0);
    this.closeBtn.interactive = true;
    this.closeBtn.cursor = 'pointer';
    this.closeBtn.on('pointertap', () => {
      this.hide();
      if (this.onClose) this.onClose();
    });
    this.addChild(this.closeBtn);
  }

  this.interactive = true;
  this.on('wheel', (event) => {
    this.handleScroll(event);
  });

  // Add touch event listeners for mobile scrolling
  this.initialTouchY = 0;
  this.on('touchstart', this.onTouchStart, this);
  this.on('touchmove', this.onTouchMove, this);
  this.on('touchend', this.onTouchEnd, this);

  // Initial layout
  this.layoutContent();
  }

  drawOverlay() {
    this.overlay.clear();
    this.overlay.beginFill(0x222a33, 1);
    this.overlay.drawRect(0, 0, window.innerWidth, window.innerHeight);
    this.overlay.endFill();
  }

  drawMask() {
    this.maskGraphics.clear();
    const maskWidth = window.innerWidth - 80;
    const maskHeight = window.innerHeight - 80;
    this.maskGraphics.beginFill(0xffffff);
    this.maskGraphics.drawRect(0, 0, maskWidth, maskHeight);
    this.maskGraphics.endFill();
    this.maskGraphics.x = 40;
    this.maskGraphics.y = 40;
  }

  layoutContent() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Responsive parameters for text and layout
    let horizontalPadding = 40;
    let titleFontSize = 40;
    let rulesTitleFontSize = 36;
    let bulletFontSize = 18;
    let functionsTitleFontSize = 36;
    let functionsDescFontSize = 18;
    let headerFontSize = 28;
    let rowDescFontSize = 24;
    let featuresTitleFontSize = 36;
    let featuresDescFontSize = 18;
    let featuresBulletFontSize = 18;
    let buttonImageSize = 90;
    let rowHeight = 120;
    let tableWidth = 1200;
    let closeBtnScale = 0.5;
    let bulletLineHeight = 26;

    if (screenWidth <= 480) { // Small mobile
      horizontalPadding = 20;
      titleFontSize = 24;
      rulesTitleFontSize = 20;
      bulletFontSize = 14;
      functionsTitleFontSize = 20;
      functionsDescFontSize = 14;
      headerFontSize = 16;
      rowDescFontSize = 14;
      featuresTitleFontSize = 20;
      featuresDescFontSize = 14;
      featuresBulletFontSize = 14;
      buttonImageSize = 50;
      rowHeight = 80;
      tableWidth = screenWidth * 0.9;
      closeBtnScale = 0.35;
      bulletLineHeight = 20;
    } else if (screenWidth <= 767) { // Regular mobile
      horizontalPadding = 30;
      titleFontSize = 32;
      rulesTitleFontSize = 28;
      bulletFontSize = 16;
      functionsTitleFontSize = 28;
      functionsDescFontSize = 16;
      headerFontSize = 20;
      rowDescFontSize = 16;
      featuresTitleFontSize = 28;
      featuresDescFontSize = 16;
      featuresBulletFontSize = 16;
      buttonImageSize = 70;
      rowHeight = 100;
      tableWidth = screenWidth * 0.8;
      closeBtnScale = 0.4;
      bulletLineHeight = 22;
    }

    this.content.x = horizontalPadding;
    this.content.y = horizontalPadding;

    const contentAreaWidth = screenWidth - 2 * horizontalPadding;
    let currentY = 0;

    // Title
    this.textElements.title.style.fontSize = titleFontSize;
    this.textElements.title.x = (screenWidth <= 767) ? (contentAreaWidth - this.textElements.title.width) / 2 : 0;
    this.textElements.title.y = currentY;
    currentY += this.textElements.title.height + (screenWidth <= 767 ? 10 : 20);

    // Divider
    this.divider.clear();
    this.divider.lineStyle(2, 0xcccccc, 1);
    this.divider.moveTo(0, currentY);
    this.divider.lineTo(contentAreaWidth, currentY);
    currentY += (screenWidth <= 767 ? 20 : 40);

    // Game Rules Title
    this.textElements.rulesTitle.style.fontSize = rulesTitleFontSize;
    this.textElements.rulesTitle.x = (contentAreaWidth - this.textElements.rulesTitle.width) / 2;
    this.textElements.rulesTitle.y = currentY;
    currentY += this.textElements.rulesTitle.height + (screenWidth <= 767 ? 10 : 16);

    // Rules Divider
    this.rulesDivider.clear();
    this.rulesDivider.lineStyle(2, 0xcccccc, 0.6);
    this.rulesDivider.moveTo(contentAreaWidth * 0.1, currentY);
    this.rulesDivider.lineTo(contentAreaWidth * 0.9, currentY);
    currentY += (screenWidth <= 767 ? 15 : 32);

    // Rule bullets
    this.bulletTexts.forEach((bulletText, index) => {
      bulletText.style.fontSize = bulletFontSize;
      bulletText.style.wordWrapWidth = contentAreaWidth - (screenWidth <= 767 ? 40 : 80);
      bulletText.style.lineHeight = bulletLineHeight;
      bulletText.x = (screenWidth <= 767 ? 20 : 80);
      bulletText.y = currentY;
      currentY += bulletText.height + (screenWidth <= 767 ? 2 : 4);
    });

    currentY += (screenWidth <= 767 ? 20 : 32); // Extra spacing before next section

    // Functions Title
    this.textElements.functionsTitle.style.fontSize = functionsTitleFontSize;
    this.textElements.functionsTitle.x = (contentAreaWidth - this.textElements.functionsTitle.width) / 2;
    this.textElements.functionsTitle.y = currentY;
    currentY += this.textElements.functionsTitle.height + (screenWidth <= 767 ? 10 : 16);

    // Functions Divider
    this.functionsDivider.clear();
    this.functionsDivider.lineStyle(2, 0xcccccc, 1);
    this.functionsDivider.moveTo(0, currentY);
    this.functionsDivider.lineTo(contentAreaWidth, currentY);
    currentY += (screenWidth <= 767 ? 10 : 20);

    // Functions Description
    this.textElements.functionsDesc.style.fontSize = functionsDescFontSize;
    this.textElements.functionsDesc.style.wordWrapWidth = contentAreaWidth - (screenWidth <= 767 ? 20 : 40);
    this.textElements.functionsDesc.x = (contentAreaWidth - this.textElements.functionsDesc.width) / 2;
    this.textElements.functionsDesc.y = currentY;
    currentY += this.textElements.functionsDesc.height + (screenWidth <= 767 ? 20 : 40);

    // Table
    const col1Width = buttonImageSize + (screenWidth <= 767 ? 10 : 40); // Image + padding
    const col2Width = tableWidth - col1Width;
    const tableXOffset = (contentAreaWidth - tableWidth) / 2;

    this.tableBorder.clear();
    this.tableBorder.lineStyle(2, 0xffffff, 0.2);
    this.tableBorder.drawRect(tableXOffset, currentY, tableWidth, rowHeight * this.tableRows.length + rowHeight); // + rowHeight for header

    this.headerBg.clear();
    this.headerBg.beginFill(0x3d186b, 1);
    this.headerBg.drawRect(tableXOffset, currentY, tableWidth, rowHeight);
    this.headerBg.endFill();

    // Table Headers
    this.textElements.buttonHeader.style.fontSize = headerFontSize;
    this.textElements.buttonHeader.x = tableXOffset + col1Width / 2 - this.textElements.buttonHeader.width / 2;
    this.textElements.buttonHeader.y = currentY + rowHeight / 2 - this.textElements.buttonHeader.height / 2;

    this.textElements.functionHeader.style.fontSize = headerFontSize;
    this.textElements.functionHeader.x = tableXOffset + col1Width + 20; // Adjusted for better alignment
    this.textElements.functionHeader.y = currentY + rowHeight / 2 - this.textElements.functionHeader.height / 2;

    currentY += rowHeight; // Move past header row

    this.tableRows.forEach((row, i) => {
      // Row border
      row.rowLine.clear();
      row.rowLine.lineStyle(1, 0xffffff, 0.2);
      row.rowLine.moveTo(tableXOffset, currentY);
      row.rowLine.lineTo(tableXOffset + tableWidth, currentY);

      // Button image
      if (row.sprite) {
        row.sprite.width = buttonImageSize;
        row.sprite.height = buttonImageSize;
        row.sprite.x = tableXOffset + col1Width / 2 - row.sprite.width / 2;
        row.sprite.y = currentY + rowHeight / 2 - row.sprite.height / 2;
      }

      // Description text
      row.desc.style.fontSize = rowDescFontSize;
      row.desc.style.wordWrapWidth = col2Width - (screenWidth <= 767 ? 20 : 40); // Adjusted padding
      row.desc.x = tableXOffset + col1Width + (screenWidth <= 767 ? 10 : 40); // Adjusted padding
      row.desc.y = currentY + rowHeight / 2 - row.desc.height / 2;

      currentY += rowHeight;
    });


    currentY += (screenWidth <= 767 ? 20 : 40); // Extra spacing after table

    // Features Title
    this.textElements.featuresTitle.style.fontSize = featuresTitleFontSize;
    this.textElements.featuresTitle.x = (contentAreaWidth - this.textElements.featuresTitle.width) / 2;
    this.textElements.featuresTitle.y = currentY;
    currentY += this.textElements.featuresTitle.height + (screenWidth <= 767 ? 10 : 16);

    // Features Divider
    this.featuresDivider.clear();
    this.featuresDivider.lineStyle(2, 0xcccccc, 1);
    this.featuresDivider.moveTo(0, currentY);
    this.featuresDivider.lineTo(contentAreaWidth, currentY);
    currentY += (screenWidth <= 767 ? 10 : 20);

    // Features Description
    this.textElements.featuresDesc.style.fontSize = featuresDescFontSize;
    this.textElements.featuresDesc.style.wordWrapWidth = contentAreaWidth - (screenWidth <= 767 ? 20 : 40);
    this.textElements.featuresDesc.x = (contentAreaWidth - this.textElements.featuresDesc.width) / 2;
    this.textElements.featuresDesc.y = currentY;
    currentY += this.textElements.featuresDesc.height + (screenWidth <= 767 ? 10 : 20);

    // Feature bullets
    this.featureBullets.forEach(bulletText => {
      bulletText.style.fontSize = featuresBulletFontSize;
      bulletText.style.wordWrapWidth = contentAreaWidth - (screenWidth <= 767 ? 40 : 80);
      bulletText.style.lineHeight = bulletLineHeight;
      bulletText.x = (screenWidth <= 767 ? 20 : 80);
      bulletText.y = currentY;
      currentY += bulletText.height + (screenWidth <= 767 ? 2 : 4);
    });

    // Close button
    this.closeBtn.scale.set(closeBtnScale);
    this.closeBtn.x = screenWidth - horizontalPadding;
    this.closeBtn.y = horizontalPadding;

    // Mask positioning
    this.maskGraphics.x = horizontalPadding;
    this.maskGraphics.y = horizontalPadding;
    this.maskGraphics.clear();
    this.maskGraphics.beginFill(0xffffff);
    this.maskGraphics.drawRect(0, 0, contentAreaWidth, screenHeight - 2 * horizontalPadding);
    this.maskGraphics.endFill();

    // Ensure content.y is clamped after layout
    const maskHeight = screenHeight - 2 * horizontalPadding;
    const minY = Math.min(horizontalPadding, maskHeight + horizontalPadding - this.content.height);
    if (this.content.y < minY) this.content.y = minY;
  }

  resizePopup() {
    this.drawOverlay();
    this.drawMask();
    this.layoutContent();
  }

  handleScroll(event) {
    const delta = event.deltaY || event.data.originalEvent.deltaY;
    this.updateContentPosition(-delta * 0.5);
  }

  onTouchStart(event) {
    this.initialTouchY = event.data.global.y;
    // Stop any ongoing scrolling animation if applicable
  }
  
  onTouchMove(event) {
    if (this.initialTouchY === null) return;
  
    const currentTouchY = event.data.global.y;
    const deltaY = currentTouchY - this.initialTouchY;
    this.initialTouchY = currentTouchY;
  
    this.updateContentPosition(deltaY * 1.5); // Adjust sensitivity
  }
  
  onTouchEnd() {
    this.initialTouchY = null;
    
  }
  
  updateContentPosition(delta) {
    const horizontalPadding = window.innerWidth <= 767 
      ? (window.innerWidth <= 480 ? 20 : 30) 
      : 40;
  
    const maskHeight = window.innerHeight - 2 * horizontalPadding;
    const contentHeight = this.content.height;
  
    // Calculate min and max Y positions for content scrolling
    const minY = Math.min(horizontalPadding, maskHeight + horizontalPadding - contentHeight);
    const maxY = horizontalPadding;
  
    this.content.y += delta; // Apply delta directly
    
    // Clamp content.y to prevent scrolling out of bounds
    if (this.content.y > maxY) this.content.y = maxY;
    if (this.content.y < minY) this.content.y = minY;
  }
  

  show() {
    this.visible = true;
    this.zIndex = 9999;
    if (this.parent) this.parent.setChildIndex(this, this.parent.children.length - 1);
    this.layoutContent();
    if (this.onShow) this.onShow();
  }

  hide() {
    this.visible = false;
    if (this.onHide) this.onHide();
  }

  updateLanguage() {
    // Update all text elements' content
    this.textElements.title.text = languageManager.getText('helpPage.title');
    this.textElements.rulesTitle.text = languageManager.getText('helpPage.rulesTitle');
    
    this.bulletTexts.forEach((bulletText, index) => {
      bulletText.text = '• ' + languageManager.getText(`helpPage.rule${index + 1}`);
    });
  
    this.textElements.functionsTitle.text = languageManager.getText('helpPage.functionsTitle');
    this.textElements.functionsDesc.text = languageManager.getText('helpPage.functionsDesc');
    this.textElements.buttonHeader.text = languageManager.getText('helpPage.buttonHeader');
    this.textElements.functionHeader.text = languageManager.getText('helpPage.functionHeader');
  
    this.tableRows.forEach(row => {
      row.desc.text = languageManager.getText(row.descKey);
    });
  
    this.textElements.featuresTitle.text = languageManager.getText('helpPage.featuresTitle');
    this.textElements.featuresDesc.text = languageManager.getText('helpPage.featuresDesc');
  
    const featureBulletData = [ 
      languageManager.getText('helpPage.bonusFeature'),
      languageManager.getText('helpPage.scatterFeature'),
    ];
    this.featureBullets.forEach((bulletText, index) => {
      bulletText.text = '• ' + featureBulletData[index];
    });
  
    // Re-layout content to adjust for new text dimensions
    this.layoutContent();
  }
} 